<template>
    <div style="height:100%;">
        <div id="csContainer"></div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        data() {
            return {
                cart3: Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, 0.0)
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                let vw = util.getViewer("csContainer");
                this.vw = vw;
                let urlMaterialImg = "img/material/star.jpg";
                let model = this._createModel();
                model.readyPromise.then(function () {
                    console.log("进入readyPromise1");
                    let textureIndexToReplace = 0;
                    let textures = model._rendererResources.textures;
                    let texture = textures[textureIndexToReplace];
                    Cesium.Resource.fetchImage({
                        url: urlMaterialImg
                    }).then(function (img2) {
                        texture.copyFrom(img2);
                        texture.generateMipmap(); // Also replaces textures in mipmap
                    });
                });
            },
            _createModel() {
                let viewer = this.vw;
                let scene = viewer.scene;
                viewer.entities.removeAll();

                let url = "/demo/static/data/models/balloon.glb";

                let origin = this.cart3;
                let modelMatrix = Cesium.Transforms.headingPitchRollToFixedFrame(origin, new Cesium.HeadingPitchRoll(0.0, 0.0, 0.0));

                let model = scene.primitives.add(Cesium.Model.fromGltf({
                    url: url,
                    modelMatrix: modelMatrix,
                    minimumPixelSize: 128,
                    incrementallyLoadTextures: false,
                
                }));
                model.readyPromise.then(function (model) {
                    console.log("进入readyPromise2");
                    let camera = viewer.camera;

                    // Zoom to model
                    let controller = scene.screenSpaceCameraController;
                    let r = 2.0 * Math.max(model.boundingSphere.radius, camera.frustum.near);
                    controller.minimumZoomDistance = r * 0.5;

                    let center = Cesium.Matrix4.multiplyByPoint(model.modelMatrix, model.boundingSphere.center, new Cesium.Cartesian3());
                    let heading = Cesium.Math.toRadians(230.0);
                    let pitch = Cesium.Math.toRadians(-20.0);
                    camera.lookAt(center, new Cesium.HeadingPitchRange(heading, pitch, r * 2.0));
                }).otherwise(function (error) {
                    window.alert(error);
                });

                return model;
            }
        }
    }
</script>

<style scoped>
    #csContainer {
        height: 100%;
    }
</style>
